import { render, staticRenderFns } from "./LoginReturn.vue?vue&type=template&id=218ef553&scoped=true"
import script from "./LoginReturn.vue?vue&type=script&lang=js"
export * from "./LoginReturn.vue?vue&type=script&lang=js"
import style0 from "./LoginReturn.vue?vue&type=style&index=0&id=218ef553&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218ef553",
  null
  
)

export default component.exports